import * as swcHelpers from '@swc/helpers';
import { validateResponse } from '../response.js';
import { acceptJson } from '../shared.js';
import { coordinatesResponseSpec } from './specs.js';

const getCoordinates = function() {
    var _ref = swcHelpers.asyncToGenerator(function*(apiUrl, request) {
        return validateResponse(coordinatesResponseSpec, (yield fetch(`${apiUrl}/address/coordinates?address=${request.query}`, {
            method: 'GET',
            headers: swcHelpers.objectSpread({}, acceptJson)
        })));
    });
    return function getCoordinates(apiUrl, request) {
        return _ref.apply(this, arguments);
    };
}();

export { getCoordinates };
//# sourceMappingURL=coordinates.js.map
